import {ShowHide} from './ShowHideClass';

export class Popover {
    popover: HTMLElement;

    constructor(popover: HTMLElement) {
        this.popover = popover;
        this.init();
    }

    init() {
        new ShowHide(
            this.popover.querySelector('[data-popover-trigger]'),
            this.popover.querySelector('[data-popover-target]'),
            true,
            false
        );
    }
}
